import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { ProductAttribute } from "../types/slices/productAttributesType"
import { TypeAttributeAPI } from "../apis/TypeAttributeAPI"
import { changeStatus, onSetSelectedtypeAttribute, selectTypeAttributeState, setAction } from "../redux/slices/typeAttributeSlice"

export const useTypeAttributeStore = () => {

    const dispatch = useDispatch()
    const { typeAttributes, typeAttributeSelected, status, action } = useSelector(selectTypeAttributeState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const gettypeAttribute = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeAttributeAPI.gettypeAttribute({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const gettypeAttributeByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeAttributeAPI.gettypeAttributeByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createtypeAttribute = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeAttributeAPI.createtypeAttribute({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const edittypeAttribute = async (idattribute: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeAttributeAPI.edittypeAttribute(idattribute, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const changeStatustypeAttribute = async (idattribute: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeAttributeAPI.changeStatustypeAttribute(idattribute, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deletetypeAttribute = async (idattribute: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeAttributeAPI.deletetypeAttribute(idattribute)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedStore = (store: ProductAttribute) => {
        try {
            dispatch(onSetSelectedtypeAttribute(store))
        } catch (error) {
            console.log(error)
        }
    }

    const setActiontypeAttribute = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        typeAttributes,
        typeAttributeSelected,
        status,
        action,
        //actions
        gettypeAttribute,
        gettypeAttributeByCompany,
        createtypeAttribute,
        edittypeAttribute,
        changeStatustypeAttribute,
        deletetypeAttribute,
        setSelectedStore,
        setActiontypeAttribute
    }
}